<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app" >
    <router-view  />
    <v-modal name="alert" 
      @before-open="setModal"
      :width="'100%'"
      height="auto"
      :maxWidth="modalparam.width ? modalparam.width : 400"
      :adaptive="true"
    >
      <div class="onlyDark">
        <div style="padding:0.5rem 1rem; font-size: 16px; background:rgba(var(--vs-primary), 1) !important" class="card-color ">
          <strong style="font-size:16px; color:#fff;" class="modalCont darkWhiteColor">{{modalparam.title ?  modalparam.title : '알림'}}</strong>
        </div>
        <div style="padding:1rem; text-align:center; word-break:keep-all; font-size: 15px;" class="modalCont darkWhiteColor" v-html="modalparam.msg">
        </div>
      </div>
    </v-modal>
    <v-modal name="alertConfirm" 
      @before-open="setModal2"
      @opened="focusEvent"
      height="auto"
      :width="'100%'"
      :maxWidth="modalConfirm.width ? modalConfirm.width : 400"
      :adaptive="true"
      scrollable
    >
      <div class="onlyDark">
        <div style="padding:0.5rem 1rem; font-size: 16px;" class="card-color ">
          <strong style="font-size:16px; " class="modalCont darkWhiteColor">{{modalConfirm.title ?  modalConfirm.title : '알림'}}</strong>
        </div>
        <div style="padding:1rem; text-align:center; word-break:keep-all; font-size: 15px;" class="modalCont darkWhiteColor" v-html="modalConfirm.msg">
        </div>
        <div class="vx-row">
            <div class="vx-col m-auto mt-6 mb-6" v-if="modalConfirm.action">
              <vs-button color="danger" @click.native="closeModal('alertConfirm')"  type="filled">취소</vs-button>
              <vs-button ref="button"  color="success" class="ml-3" id="confirmOk" :autofocus="modalConfirm.autofocus" @click.native="modalConfirmAction" type="filled">확인</vs-button>
            </div>
        </div>
      </div>
    </v-modal>
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'

//import jwt         from '@/http/requests/auth/jwt/index.js'

export default {
  data () {
    return {
      vueAppClasses: [],
      modalparam : {},
      modalConfirm : {
        title: null,
        msg :null,
        width:null,
        action : null,
      }
    }
  },
  watch: {
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    }
  },
  methods: {
    setModal(data){
      this.modalparam = data['params']
    },
    setModal2(data){
      console.log(data);
      this.modalConfirm = data['params']
    },
    focusEvent(data){
      console.log('focus',data)
      if(this.$refs.button){
        if(this.modalConfirm.autofocus){
          this.$refs.button.$el.autofocus = true
          this.$refs.button.$el.focus();
        }
      }
    },
    modalConfirmAction (){
      this.modalConfirm.action()
      this.closeModal('alertConfirm');
    },
    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  mounted () {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  },
  
  async created () {

    // jwt
    //jwt.init()

    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

    // Auth0
    // try       { await this.$auth.renewTokens() } catch (e) { console.error(e) }

  },
  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}

</script>
